module services {
    export module master {
        export class productColourService implements interfaces.master.IProductColourService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all Product Types for a dropdown/autocomplete list
            getDropdownList(): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "ProductColour/GetDropdownList", {
                        ownerEntityId: '@ownerEntityId'
                    }, {
                            query: {
                                method: 'GET',
                                isArray: true
                            }
                        });
            }
        }
    }
    angular.module("app").service("productColourService", services.master.productColourService);
}